import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// iOS Safari bfcache: re-render fix (blank sticky headers after back-swipe)
window.addEventListener("pageshow", (e) => {
  if (e.persisted) window.location.reload();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
